import React from 'react';
import cx from 'classnames';

export const BulkPaymentsTableRow = ({
    index,
    label,
    value,
}: BulkPaymentsTableRowProps): JSX.Element => (
    <tr
        style={{ height: 30 }}
        className={cx({
            'bg-highlight-palelavender': index % 2 === 0,
        })}
    >
        <td className="font-semibold px-2">{value}</td>
        <td className="px-2">{label}</td>
    </tr>
);
